<template>
  <div class="data-view-container" @click="$emit('click')">
    <div class="data-view-label">{{ label }}:</div>
    <div class="data-view-description">{{ displayDescription }}</div>
    <div class="data-view-icon" :class="iconClass"></div>
  </div>
</template>

<script>
const URL_REG_EXP = /(^\w+:|^)\/\/|\/$/g;
const DEFAULT_ICON = 'copy';

export default {
  name: 'dataViewData',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default() {
        return DEFAULT_ICON;
      },
    },
    description: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconClass() {
      return `icon-${this.icon}`;
    },
    displayDescription() {
      const description = this.description || '';

      if (URL_REG_EXP.test(description)) {
        return description.replace(URL_REG_EXP, '');
      }

      return description;
    },
  },
};
</script>

<style lang="sass" scoped>
  .data-view-container
    width: 100%
    height: 40px
    position: relative
    display: flex
    flex-direction: row
    align-items: center
    font-weight: 500
    font-size: 12px
    line-height: 20px
    border-radius: 50px
    cursor: pointer
    box-sizing: border-box

    +respond-to('small')
      padding: 0 20px

      #{theme('eclipse')} &
        background: linear-gradient(360deg, rgba(91, 204, 126, 0.21) 42.31%, rgba(123, 211, 255, 0) 107.31%)

      #{theme('obsidian')} &
        background-color: #181823

    &:hover
      .data-view-description
        color: #9B51E0

      .icon-copy
        background-image: get-icon('copy', #9B51E0)

      .icon-settings
        background-image: get-icon('settings', #9B51E0)

  .data-view-label
    margin-right: 10px

    #{theme('eclipse')} &
      color: #212121

    #{theme('obsidian')} &
      color: #fff

  .data-view-description
    width: 100%
    flex: 1
    font-size: 14px
    color: #7CB342
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    transition: all .2s ease

    +respond-to('small')
      width: auto
      padding: 0 10px

  .data-view-icon
    width: 15px
    height: 15px
    margin: 0 10px
    background:
      size: cover
      repeat: no-repeat
      position: center center
    transition: all .2s ease

    +respond-to('small')
      margin: 0

  .icon-copy
    background-image: get-icon('copy', #7cb342)

  .icon-settings
    background-image: get-icon('settings', #7cb342)
</style>
